import { OperatorReworkModel } from "./operator-rework.model";

export class LineOperatorsReworkModel {
    lineId: string;
    lineDesc: string;
    operatorInfo: OperatorReworkModel[];
    
    constructor(lineId: string,
        lineDesc: string,
        operatorInfo: OperatorReworkModel[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.operatorInfo = operatorInfo;
    }
}